import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import { FormField, inputBaseStyles } from './FormField'

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'required'> {
  label?: string
  error?: string
  helperText?: string
  required?: boolean
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', required, ...props }, ref) => {
    return (
      <FormField label={label} error={error} helperText={helperText} required={required} htmlFor={props.id}>
        <input
          ref={ref}
          className={inputBaseStyles(error, className)}
          aria-required={required}
          {...props}
        />
      </FormField>
    )
  }
)

Input.displayName = 'Input'

export default Input
